import { UntypedFormGroup } from '@angular/forms';
import { createAction, props } from '@ngrx/store';

import { UserCreate, UserLogin, UserSocialLogin } from '@api/users/user.models';
import { PublicUser } from '@features/user';
import { DialogSizes, DialogMargins, DialogOptions, DialogPosition } from '@ui/dialog/dialog.service';

/**
 * Creación de las acciones de Redux para el usuario actaul
 */
export const AuthenticationActionTypes = {
    CHANGE_PASSWORD_ERROR: '[authentication] CHANGE_PASSWORD_ERROR',
    CHANGE_PASSWORD_SUCCESS: '[authentication] CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD: '[authentication] CHANGE_PASSWORD',
    CLOSE_MODAL_FROM_COMPONENT: '[authentication] CLOSE_MODAL_FROM_COMPONENT',
    DO_GOOGLE_LOGIN_V1: '[authentication] DO_GOOGLE_LOGIN_V1',
    LOGIN_INITIALIZED: '[analytics-authentication] LOGIN_INITIALIZED',
    LOGIN_HANDLE_REDIRECT: '[analytics-authentication] LOGIN_HANDLE_REDIRECT',
    LOGIN_HANDLE_REDIRECT_SUCCESS: '[analytics-authentication] LOGIN_HANDLE_REDIRECT_SUCCESS',
    LOGIN_USER_ERROR: '[authentication] LOGIN_USER_ERROR',
    LOGIN_USER_SUCCESS_REDIRECT: '[authentication] LOGIN USER SUCCESS REDIRECT]',
    LOGIN_USER_SUCCESS: '[authentication] LOGIN_USER_SUCCESS',
    LOGIN_USER: '[authentication] LOGIN_USER',
    OPEN_MODAL_FROM_COMPONENT: '[authentication] OPEN_MODAL_FROM_COMPONENT',
    RECOVERY_PASSWORD_INITIALIZED: '[authentication] RECOVERY_PASSWORD_INITIALIZED',
    REGISTER_CONFIRMATION_CONTINUE: '[authentication] REGISTER_CONFIRMATION_CONTINUE',
    REGISTER_CONFIRMATION_INITIALIZED: '[authentication] REGISTER_CONFIRMATION_INITIALIZED',
    REGISTER_INITIALIZED: '[analytics-authentication] REGISTER_INITIALIZED',
    REGISTER_USER_ERROR: '[authentication] REGISTER_USER_ERROR',
    REGISTER_USER_SUCCESS: '[authentication] REGISTER_USER_SUCCESS',
    REGISTER_USER: '[authentication] REGISTER_USER',
    RESET_PASSWORD_ERROR: '[authentication] RESET_PASSWORD_ERROR',
    RESET_PASSWORD_SUCCESS: '[authentication] RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD: '[authentication] RESET_PASSWORD',
    SOCIAL_LOGIN_USER_ERROR: '[authentication] SOCIAL_LOGIN_USER_ERROR',
    SOCIAL_LOGIN_USER_SUCCESS: '[authentication] SOCIAL_LOGIN_USER_SUCCESS',
    SOCIAL_LOGIN_USER_V2: '[authentication] SOCIAL_LOGIN_USER_V2',
    SOCIAL_LOGIN_USER: '[authentication] SOCIAL_LOGIN_USER',
    PHONE_CODE_VERIFICATION: '[authentication] PHONE_CODE_VERIFICATION',
    PHONE_CODE_VERIFICATION_ERROR: '[authentication] PHONE_CODE_VERIFICATION_ERROR',
    PHONE_CODE_VERIFICATION_SUCCESS: '[authentication] PHONE_CODE_VERIFICATION_SUCCESS',
    LAUNCH_LINKED_ACCOUNT_MODAL: '[authentication] LAUNCH_LINKED_ACCOUNT_MODAL',
    // TODO ECOMDUTI-20997 Revisar si esto debe trasladarse a User actions o cambiar User por authentication
    SET_LINKED_ACCOUNT: '[User] SET_LINKED_ACCOUNT',
    SET_LINKED_ACCOUNT_SUCCESS: '[User] SET_LINKED_ACCOUNT_SUCCESS',
    SET_LINKED_ACCOUNT_ERROR: '[User] SET_LINKED_ACCOUNT_ERROR',
    DECLINE_LINKED_ACCOUNT: '[User] DECLINE_LINKED_ACCOUNT',
};

export const LoginInitialized = createAction(
    AuthenticationActionTypes.LOGIN_INITIALIZED,
    props<{ additionalValues?: any }>()
);

export const LoginHandleRedirect = createAction(
    AuthenticationActionTypes.LOGIN_HANDLE_REDIRECT,
    props<{ audience: string; data: any }>()
);

export const LoginHandleRedirectSuccess = createAction(
    AuthenticationActionTypes.LOGIN_HANDLE_REDIRECT_SUCCESS,
    props<{ data: any }>()
);

export const RegisterInitialized = createAction(
    AuthenticationActionTypes.REGISTER_INITIALIZED,
);

export const RegisterConfirmationInitialized = createAction(
    AuthenticationActionTypes.REGISTER_CONFIRMATION_INITIALIZED,
);

export const RecoveryPasswordInitialized = createAction(
    AuthenticationActionTypes.RECOVERY_PASSWORD_INITIALIZED,
);

export const RegisterAction = createAction(
    AuthenticationActionTypes.REGISTER_USER,
    props<{ isCompany: boolean; form: UntypedFormGroup; additionalValues?: any }>()
);

export const RegisterSuccessAction = createAction(
    AuthenticationActionTypes.REGISTER_USER_SUCCESS,
    props<{ user: PublicUser; form: UntypedFormGroup; userParams?: UserCreate }>()
);
export const RegisterErrorAction = createAction(
    AuthenticationActionTypes.REGISTER_USER_ERROR,
    props<{ error: string; errorData: Record<string, any> }>()
);
export const RegisterConfirmationContinueAction = createAction(
    AuthenticationActionTypes.REGISTER_CONFIRMATION_CONTINUE,
);

export const LoginAction = createAction(
    AuthenticationActionTypes.LOGIN_USER,
    props<{ userLogin: UserLogin; skipRedirect?: boolean }>()
);

export const SocialLoginAction = createAction(
    AuthenticationActionTypes.SOCIAL_LOGIN_USER,
    props<{ userLogin: UserSocialLogin }>()
);

export const SocialLoginV2Action = createAction(
    AuthenticationActionTypes.SOCIAL_LOGIN_USER_V2,
    props<{ userLogin: UserSocialLogin }>()
);

export const SocialLoginErrorAction = createAction(
    AuthenticationActionTypes.SOCIAL_LOGIN_USER_ERROR,
    props<{ error: string; errorData?: any; userData?: any; newVersion?: boolean }>()
);

export const SocialLoginSuccessAction = createAction(
    AuthenticationActionTypes.SOCIAL_LOGIN_USER_SUCCESS,
    props<{ user: PublicUser; socialData: UserSocialLogin }>()
);

export const DoGoogleLoginV1 = createAction(
    AuthenticationActionTypes.DO_GOOGLE_LOGIN_V1,
    props<{ accessToken: string }>()
);

export const LoginSuccessAction = createAction(
    AuthenticationActionTypes.LOGIN_USER_SUCCESS,
    props<{
        user: PublicUser;
        options?: {
            rememberMe?: boolean;
            skipRedirect?: boolean;
        };
        socialData?: UserSocialLogin;
    }>()
);

export const LoginSuccessActionRedirect = createAction(
    AuthenticationActionTypes.LOGIN_USER_SUCCESS_REDIRECT
);

export const LoginErrorAction = createAction(
    AuthenticationActionTypes.LOGIN_USER_ERROR,
    props<{ error: string; errorData: any; socialData?: UserSocialLogin }>()
);

export const ResetPasswordAction = createAction(
    AuthenticationActionTypes.RESET_PASSWORD,
    props<{ data: any }>()
);
export const ResetPasswordSuccessAction = createAction(
    AuthenticationActionTypes.RESET_PASSWORD_SUCCESS
);
export const ResetPasswordErrorAction = createAction(
    AuthenticationActionTypes.RESET_PASSWORD_ERROR,
    props<{ error: string }>()
);

export const PhoneCodeVerification = createAction(
    AuthenticationActionTypes.PHONE_CODE_VERIFICATION,
    props<{ form: UntypedFormGroup }>()
);

export const PhoneCodeVerificationSuccess = createAction(
    AuthenticationActionTypes.PHONE_CODE_VERIFICATION_SUCCESS
);
export const PhoneCodeVerificationError = createAction(
    AuthenticationActionTypes.PHONE_CODE_VERIFICATION_ERROR,
    props<{ error: string }>()
);

export const ChangePasswordAction = createAction(
    AuthenticationActionTypes.CHANGE_PASSWORD,
    props<{ data: any }>()
);
export const ChangePasswordSuccessAction = createAction(
    AuthenticationActionTypes.CHANGE_PASSWORD_SUCCESS
);

export const ChangePasswordErrorAction = createAction(
    AuthenticationActionTypes.CHANGE_PASSWORD_ERROR,
    props<{ error: string }>()
);

// TOD ECOMDUTI-20997: Mover a un módulo superior si se quiere utilizar en otras páginas
export const OpenModalFromComponentAction = createAction(
    AuthenticationActionTypes.OPEN_MODAL_FROM_COMPONENT,
    props<{
        title: string;
        component: string; // Inicialmente la idea era pasar el componente pero hay problemas al pasar por parámetro cosas que no sean objetos simples
        data: any;
        size: DialogSizes;
        margin: DialogMargins;
        modalOptions?: Array<DialogOptions | DialogPosition>;
        icon: string;
    }>()
);

export const CloseModalFromComponentAction = createAction(
    AuthenticationActionTypes.CLOSE_MODAL_FROM_COMPONENT,
    props<{
        component: any;
        modalRef?: any;
    }>()
);

export const LaunchLinkedAccountModal = createAction(AuthenticationActionTypes.LAUNCH_LINKED_ACCOUNT_MODAL);
export const SetLinkedAccount = createAction(AuthenticationActionTypes.SET_LINKED_ACCOUNT);
export const SetLinkedAccountSuccess = createAction(AuthenticationActionTypes.SET_LINKED_ACCOUNT_SUCCESS);
export const SetLinkedAccountError = createAction(
    AuthenticationActionTypes.SET_LINKED_ACCOUNT_ERROR,
    props<{ error: any }>()
);
export const DeclineLinkedAccount = createAction(AuthenticationActionTypes.DECLINE_LINKED_ACCOUNT);
